import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
export var TopicGuideContextDefaultValue = {
  showFloatTopicGuide: false,
  setShowFloatTopicGuide: function setShowFloatTopicGuide() {},
  setIsMemoAbleToAddOnFloatTopicGuide: function setIsMemoAbleToAddOnFloatTopicGuide() {},
  floatTopicGuideWidth: '364px',
  onAddMemo: function onAddMemo() {},
  topicGuides: {},
  isGetTopicGuidesPending: false,
  isOnAddMemoMutatePending: false,
  isMemoAbleToAddOnFloatTopicGuide: false
};
export var getGroupedTopicGuides = function getGroupedTopicGuides(topicGuides) {
  var grouped = R.pipe(R.filter(function (item) {
    return R.isNotNil(item.topic_guide);
  }), R.groupBy(R.propOr('', 'survey_answer_id')), R.reject(R.isNil), R.values, R.reject(R.isNil), R.map(function (item) {
    var _item$, _item$2;

    return R.reduce(function (acc, cur) {
      // merge answer and topic_guide
      var guide = R.pick(['answer', 'topic_guide'], cur);
      return _objectSpread(_objectSpread({}, acc), {}, {
        guides: [].concat(_toConsumableArray(acc.guides), [guide])
      });
    }, {
      question_title: item[0].question_title,
      client_memos: (_item$ = item[0]) === null || _item$ === void 0 ? void 0 : _item$.client_memos,
      survey_answer_id: (_item$2 = item[0]) === null || _item$2 === void 0 ? void 0 : _item$2.survey_answer_id,
      guides: []
    }, item);
  }))(topicGuides);
  return grouped;
};